import {Inject, Injectable} from '@angular/core';
import {TableService} from '../../../_metronic/shared/crud-table';
import {HttpClient} from '@angular/common/http';
import {SingleProjectModel} from '../_models/singleProject.model';

@Injectable({
    providedIn: 'root'
})
export class ProjectsService extends TableService<SingleProjectModel> {
    constructor(@Inject(HttpClient) http) {
        super(http);
    }


    getClients() {
        return this.http.get('/api/getAllMyClients');
    }

    getCurrentUser() {
        return this.http.get('/api/getCurrentUser');
    }

    getAllContracts() {
        return this.http.get('/api/getMainIdContracts');
    }

    getUserById(id: string) {
        return this.http.get('/api/getUserById?userId=' + id);
    }

    getAllUsers() {
        return this.http.get('/api/getMainIdUsers');
    }

    getUsersProducts() {
        return this.http.get('/api/getMainUserProducts');
    }

    getAllProjects() {
        return this.http.get('/api/getAllProjects');
    }

    getMainIdProjects() {
        return this.http.get('/api/getMainIdProjects');
    }

    getUserSubUsers() {
        return this.http.get('/api/getUserSubUsers');
    }

    getTeamMembers(includeCurrentUser: boolean, withInactiveUsers: boolean) {
        return this.http.get('/api/getTeamMembers?includeCurrentUser=' + includeCurrentUser + '&withInactiveUsers=' + withInactiveUsers);
    }

    getTaskById(taskId: string) {
        return this.http.get('/api/getTaskERPById?taskERPId=' + taskId);
    }

    getAllProjectTasks(projectId: string) {
        return this.http.get('/api/getAllProjectTasks?projectId=' + projectId);
    }

    createTaskERP(projectId: string, stage: string, task: any) {
        return this.http.post('/api/createTaskERP?projectId=' + projectId + '&stage=' + stage, task);
    }

    createTaskERPNoStage(projectId: string, task: any) {
        return this.http.post('/api/createTaskERP?projectId=' + projectId, task);
    }

    updateTaskERP(taskId: string, updatedTask) {
        return this.http.put('/api/updateTaskERP?taskERPId=' + taskId, updatedTask);
    }

    changeTaskERPStatus(taskId, status) {
        return this.http.put('/api/changeTaskERPStatus?taskERPId=' + taskId + '&status=' + status, {});
    }

    updateSubtaskList(taskId: string, subTaskList: [{}]) {
        return this.http.put('/api/updateSubtaskList?taskERPId=' + taskId, subTaskList);
    }

    changeProjectStatus(projectId: string, status: string) {
        return this.http.put('/api/changeProjectStatus?projectId=' + projectId + '&status=' + status, {});
    }

    updateProjectStaff(projectId: string, staff) {
        return this.http.put('/api/updateProjectStaff?projectId=' + projectId, staff);
    }

    addNewStageToProject(projectId: string, stage) {
        return this.http.put('/api/addNewStageToProject?projectId=' + projectId, stage);
    }

    updateProjectStage(projectId: string, position: number, stage) {
        return this.http.put('/api/updateProjectStage?projectId=' + projectId + '&position=' + position, stage);
    }

    changeProjectStages(projectId: string, newStages: any[]) {
        return this.http.put('/api/changeProjectStages?projectId=' + projectId, newStages);
    }

    getProjectById(projectId: string) {
        return this.http.get('/api/getProjectById?projectId=' + projectId);
    }

    getProjectCompletion(projectId: string) {
        return this.http.get('/api/getProjectCompletion?projectId=' + projectId);
    }

    getStageCompletion(projectId: string, stage) {
        return this.http.get('/api/getStageCompletion?projectId=' + projectId + '&stage=' + stage);
    }

    createProject(projectData: object) {
        return this.http.post('/api/createProject', projectData);
    }

    editProject(id: string, projectData: object) {
        return this.http.put('/api/updateProject?projectId=' + id, projectData);
    }

    getUsersFromDepartment(department: string) {
        return this.http.get('/api/getUsersFromDepartment?department=' + department);
    }

    getContactById(id: string) {
        return this.http.get('/api/getContactById?contactId=' + id);
    }

    getAllProjectList(id: string) {
        return this.http.get('/api/getAllProjectNotes?projectId=' + id);
    }

    // Notes
    addProjectNote(id: string, projectNote: object) {
        return this.http.post('/api/addProjectNote?projectId=' + id, projectNote);
    }

    getAllNotes(projectId: string) {
        return this.http.get('/api/getAllProjectNotes?projectId=' + projectId);
    }

    getSpecificNote(id: string) {
        return this.http.get('/api/getSpecificNote?noteId=' + id);
    }

    deleteSpecificNote(id: string) {
        return this.http.delete('/api/deleteSpecificNote?noteId=' + id);
    }

    editSpecificNote(id: string, note: object) {
        return this.http.put('/api/updateProjectNote?noteId=' + id, note);
    }

    deleteTaskERP(taskERPId: string) {
        return this.http.delete('/api/deleteTaskERP?taskERPId=' + taskERPId);
    }
}
